module.exports = __webpack_public_path__ + "img/image17.41695cf5.png";